import { useApi } from '@/shared/api/http';
import type {
  ISearchRequest,
  ISearchForWorkRequest,
} from '@/entities/search/model/types/search';
import type { ISearchForWorkLawyer } from '@/entities/search/model/types/searchForWork';

export const useSearchService = () => {
  const api = useApi();

  const getSearchItems = async <T>(dataReq: ISearchRequest) => {
    return await api.post<T>('lawyer/search-fulltext', dataReq);
  };

  const getSearchForWorkItems = async <T = ISearchForWorkLawyer[]>(
    dataReq: ISearchForWorkRequest = {},
  ) => {
    return await api.post<T>('lawyer/search-for-work', dataReq);
  };

  return {
    getSearchItems,
    getSearchForWorkItems,
  };
};
